// PageDescription: 의약품 정보 상세 페이지 리다이렉트
import { createMedicineDictionaryRedirectUrl } from '@/entities/medicine-dictionary/util';
import useMedicineDictionaryItemByPublicId from '@/hooks/medicine-dictionary/useMedicineDictionaryItemByPublicId';
import { withClientServerSideProps } from '@/utils/mobile/RNPlugins';
import { QueryClient } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';

// 이 페이지는 렌더링되지 않고 항상 리다이렉트됩니다
const MedicineDictionaryRedirectPage = () => {
  return null;
};

export default MedicineDictionaryRedirectPage;

export const getServerSideProps: GetServerSideProps = withClientServerSideProps(async (context) => {
  try {
    const publicId = context.params?.id;

    if (!publicId || typeof publicId !== 'string') {
      return {
        notFound: true,
      };
    }

    const queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          staleTime: 1000 * 60 * 5,
        },
      },
    });

    // 의약품 정보를 가져와서 키워드 생성
    await useMedicineDictionaryItemByPublicId.prefetchQuery(queryClient, publicId);

    // 캐시에서 데이터 가져오기
    const cachedData = queryClient.getQueryData(useMedicineDictionaryItemByPublicId.getKey(publicId)) as any;

    if (cachedData?.medicineDictionaryItemByPublicId) {
      // 통일된 메소드를 사용하여 리다이렉트 URL 생성
      const redirectUrl = createMedicineDictionaryRedirectUrl(publicId, cachedData.medicineDictionaryItemByPublicId);

      return {
        redirect: {
          destination: redirectUrl,
          permanent: true, // SEO를 위해 301 리다이렉트 사용
        },
      };
    }

    // 데이터가 없는 경우 404
    return {
      notFound: true,
    };
  } catch {
    return {
      notFound: true,
    };
  }
});
